const s = {
  MEDICAL: "MEDICAL",
  PHARMACY: "PHARMACY"
}, A = {
  [s.MEDICAL]: "Medical",
  [s.PHARMACY]: "Pharmacy"
}, N = Object.values(s).map((t) => ({
  value: t,
  name: A[t],
  text: A[t]
})), e = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  LITE: "LITE"
}, n = {
  [e.ACTIVE]: "Active",
  [e.INACTIVE]: "Inactive",
  [e.LITE]: "Lite"
}, M = Object.values(e).map((t) => ({
  value: t,
  name: n[t],
  text: n[t]
})), o = {
  ASP: "ASP",
  AWP: "AWP"
}, I = Object.values(o).map((t) => ({
  value: t,
  name: t,
  text: t
})), C = "9999999999", T = "9888888888", c = "9999999991", r = -9.9999, a = {
  AL: "AL",
  AK: "AK",
  // AS: 'AS',
  AZ: "AZ",
  AR: "AR",
  CA: "CA",
  CO: "CO",
  CT: "CT",
  DE: "DE",
  DC: "DC",
  // FM: 'FM',
  FL: "FL",
  GA: "GA",
  // GU: 'GU',
  HI: "HI",
  ID: "ID",
  IL: "IL",
  IN: "IN",
  IA: "IA",
  KS: "KS",
  KY: "KY",
  LA: "LA",
  ME: "ME",
  // MH: 'MH',
  MD: "MD",
  MA: "MA",
  MI: "MI",
  MN: "MN",
  MS: "MS",
  MO: "MO",
  MT: "MT",
  NE: "NE",
  NV: "NV",
  NH: "NH",
  NJ: "NJ",
  NM: "NM",
  NY: "NY",
  NC: "NC",
  ND: "ND",
  // MP: 'MP',
  OH: "OH",
  OK: "OK",
  OR: "OR",
  // PW: 'PW',
  PA: "PA",
  PR: "PR",
  RI: "RI",
  SC: "SC",
  SD: "SD",
  TN: "TN",
  TX: "TX",
  UT: "UT",
  VT: "VT",
  // VI: 'VI',
  VA: "VA",
  WA: "WA",
  WV: "WV",
  WI: "WI",
  WY: "WY"
}, i = {
  [a.AL]: "Alabama",
  [a.AK]: "Alaska",
  // [USStates.AS]: 'American Samoa',
  [a.AZ]: "Arizona",
  [a.AR]: "Arkansas",
  [a.CA]: "California",
  [a.CO]: "Colorado",
  [a.CT]: "Connecticut",
  [a.DE]: "Delaware",
  [a.DC]: "District of Columbia",
  // [USStates.FM]: 'Federated States of Micronesia',
  [a.FL]: "Florida",
  [a.GA]: "Georgia",
  // [USStates.GU]: 'Guam',
  [a.HI]: "Hawaii",
  [a.ID]: "Idaho",
  [a.IL]: "Illinois",
  [a.IN]: "Indiana",
  [a.IA]: "Iowa",
  [a.KS]: "Kansas",
  [a.KY]: "Kentucky",
  [a.LA]: "Louisiana",
  [a.ME]: "Maine",
  // [USStates.MH]: 'Marshall Islands',
  [a.MD]: "Maryland",
  [a.MA]: "Massachusetts",
  [a.MI]: "Michigan",
  [a.MN]: "Minnesota",
  [a.MS]: "Mississippi",
  [a.MO]: "Missouri",
  [a.MT]: "Montana",
  [a.NE]: "Nebraska",
  [a.NV]: "Nevada",
  [a.NH]: "New Hampshire",
  [a.NJ]: "New Jersey",
  [a.NM]: "New Mexico",
  [a.NY]: "New York",
  [a.NC]: "North Carolina",
  [a.ND]: "North Dakota",
  // [USStates.MP]: 'Northern Mariana Islands',
  [a.OH]: "Ohio",
  [a.OK]: "Oklahoma",
  [a.OR]: "Oregon",
  // [USStates.PW]: 'Palau',
  [a.PA]: "Pennsylvania",
  [a.PR]: "Puerto Rico",
  [a.RI]: "Rhode Island",
  [a.SC]: "South Carolina",
  [a.SD]: "South Dakota",
  [a.TN]: "Tennessee",
  [a.TX]: "Texas",
  [a.UT]: "Utah",
  [a.VT]: "Vermont",
  // [USStates.VI]: 'Virgin Islands',
  [a.VA]: "Virginia",
  [a.WA]: "Washington",
  [a.WV]: "West Virginia",
  [a.WI]: "Wisconsin",
  [a.WY]: "Wyoming"
}, D = Object.values(a).map((t) => ({
  name: i[t],
  secondaryData: t
}));
export {
  A as BenefitTypeDisplayTextMap,
  N as BenefitTypeOptions,
  s as BenefitTypes,
  r as CONTRACT_RATE,
  C as FMH_NPI,
  c as FMH_RESEARCH_NPI,
  T as FMH_UNMANAGED_NPI,
  n as NetworkStatusDisplayTextMap,
  M as NetworkStatusOptions,
  e as NetworkStatuses,
  I as ReferentPriceTypeOptions,
  o as ReferentPriceTypes,
  i as USStateNames,
  D as USStateOptions,
  a as USStates
};
//# sourceMappingURL=index.js.map
